import React, { useState, useEffect, useRef } from 'react'
import { Paper, Grid, Checkbox } from '@material-ui/core';
import moment from 'moment';
import { useHistory } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { getAllMaterials, setVendorName } from '../../../redux/actions/vendorAction'
import { getAllUnits } from '../../../redux/actions/projectAction'
import HttpService from '../../../services/httpService'
import { Table, Button, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CSVLink } from "react-csv";
import { getApprovedProjects } from '../../../redux/actions/financeAction';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  tableContainer: {
    position: 'relative',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
  filterContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1),
    marginLeft: 'auto',
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const Vendors = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const buttonRef = useRef(null);
  const { approvedProjects } = useSelector(state => state.finance)
  const [fromDateValue, setFromDateValue] = useState('')
  const [toDateValue, setToDateValue] = useState('')
  const [vendors, setVendors] = useState([])
  const [allVendorsList, setAllVendorsList] = useState([])
  const [csvData, setCsvData] = useState([]);
  const [checkArr, setcheckArr] = useState([])
  const [projectsIds, setProjectsIds] = useState([])
  const [selectedProjects, setSelectedProjects] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10)
  const [isLoadingVendors, setIsLoadingVendors] = useState(false)
  
  const headers = [
    { key: "vendorUniqueNo", label: "Vendor Unique Code" },
    { key: "poSoNumber", label: "Po/So Number" },
    { key: "poSoDate", label: "Po/So Date" },
    { key: "materialName", label: "Material Name" },
    { key: "pricePerUnit", label: "Rate" },
    { key: "quantity", label: "Qty" },
    { key: "requestedQuantity", label: "Requested Qty" },
    { key: "itemTotal", label: "Item Total Value" },
    { key: "transportationCharge", label: "Transportation Charge" },
    { key: "gstRate", label: "GST Rate" },
    { key: "discount", label: "Discount" },
    { key: "freight", label: "Fright Charge" },
    { key: "poVal", label: "PO Value" },
    { key: "materialStatus", label: "Material Status" },
    { key: "raisedBy", label: "PO Created By" },
    { key: "grnNumber", label: "GRN NUMBER" },
  ];

  const getApprovedProjects = async () => {
    try {
      props.setLoading(true)
      await props.getApprovedProjects()
      props.setLoading(false)
    } catch (error) {
      console.error(error)
      props.setLoading(false)
      props.setSnackInfo(error.response.data.message, "error")
    }
  }

  const loadAllVendorsForSearch = async () => {
    try {
      const result = await HttpService.getAllVendors()
      setAllVendorsList(result.data)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
  }

  const handleFromDateChange = (e) => {
    setFromDateValue(e.target.value)
  }

  const handleToDateChange = (e) => {
    if (fromDateValue === null) {
      props.setSnackInfo("Please select From Date first", "error")
      return
    }
    if (Date.parse(e.target.value) < Date.parse(fromDateValue)) {
      props.setSnackInfo("To Date cannot be less than from Date", "error")
      return
    }
    setToDateValue(e.target.value)
  }

  const handleCheckBox = (e, vendorId) => {
    let combineArr = []
    if (e.target.checked) {
      combineArr = [...checkArr, ...[vendorId]]
    } else {
      combineArr = [...checkArr]
      combineArr = combineArr.filter(el => el !== vendorId)
    }
    setcheckArr(combineArr)
  }

  const applyFilters = () => {
    setIsFilterApplied(true)
    setCurrentPage(1)
    getVendors(1, limit, projectsIds, fromDateValue, toDateValue)
  }

  const clearFilters = () => {
    setProjectsIds([])
    setSelectedProjects([])
    setFromDateValue('')
    setToDateValue('')
    setIsFilterApplied(false)
    setCurrentPage(1)
    // Call getVendors with empty parameters to fetch all data
    getVendors(1, limit, [], '', '')
    props.setSnackInfo("All filters cleared", "success")
  }

  const handleCsvButton = async () => {
    if (
      (fromDateValue !== null && toDateValue === null) ||
      (fromDateValue === null && toDateValue !== null)
    ) {
      props.setSnackInfo("Please enter both Dates correctly", "error");
      return;
    }

    props.setLoading(true);

    try {
      let vendorsToExport = [];
      
      if (checkArr.length > 0) {
        vendorsToExport = vendors.filter(v => checkArr.includes(v._id));
      } else if (isFilterApplied || projectsIds.length > 0 || fromDateValue || toDateValue) {
        vendorsToExport = vendors;
      } else {
        vendorsToExport = vendors;
      }

      if (vendorsToExport.length === 0) {
        props.setSnackInfo("No vendors to export", "error");
        props.setLoading(false);
        return;
      }

      let vendorsIds = vendorsToExport.map(v => v._id);
      let obj = { vendorsIds };

      let [poRes, soRes] = await Promise.all([
        HttpService.getProcurementsforVendors(obj),
        HttpService.getServiceOrdersforVendors(obj)
      ]);

      let poData = [...poRes.data, ...soRes.data];

      if (projectsIds.length > 0) {
        const projectSet = new Set(projectsIds);
        poData = poData.filter(po => projectSet.has(po.projectId?._id));
      }

      const vendorMap = new Map(vendors.map(v => [v._id, v]));
      const vendorsData = vendorsIds.map(id => vendorMap.get(id)).filter(v => v);

      const from = fromDateValue ? new Date(fromDateValue).getTime() : null;
      const to = toDateValue ? new Date(toDateValue).getTime() : null;

      let csvArray = [];

      for (let k = 0; k < vendorsData.length; k++) {
        const vendor = vendorsData[k];
        if (!vendor) continue;

        const vendorPoData = poData.filter(
          po => po.vendorId?._id == vendor._id
        );

        for (let i = 0; i < vendorPoData.length; i++) {
          const po = vendorPoData[i];

          if (from && to) {
            const created = new Date(po.createdAt).getTime();
            if (created < from || created > to) continue;
          }

          let poValue = 0;
          const materials = po.materials || [];
          const isSO = po.orderId?.[0] === "S";

          for (let j = 0; j < materials.length; j++) {
            const mat = materials[j];

            const price = isSO
              ? Number(mat?.price || 0)
              : Number(mat?.requestedPrice || 0);

            const qty = Number(mat?.requestedQuantity || 0);
            const itemTotal = price * qty;

            poValue += itemTotal;

            csvArray.push({
              vendorUniqueNo: vendor.vendorUniqueNo,
              poSoNumber: po.orderId,
              raisedBy: po.createdBy?.name || "N/A",
              grnNumber: po.allGrns || "N/A",
              poSoDate: moment(po.createdAt).format("DD-MM-YYYY"),
              materialName: mat?.materialId?.name,
              pricePerUnit: price,
              quantity: mat?.quantity,
              requestedQuantity: qty,
              itemTotal,
              materialStatus: mat?.status,
            });
          }

          if (!isSO) {
            csvArray.push({
              vendorUniqueNo: null,
              poSoNumber: null,
              raisedBy: null,
              grnNumber: null,
              poSoDate: null,
              materialName: null,
              pricePerUnit: null,
              quantity: null,
              requestedQuantity: null,
              transportationCharge: po?.transportationCharge || 0,
              itemTotal: null,
              discount: po?.discount,
              freight: po?.freight,
              gstRate: po?.gstDetails?.[0]?.rate + "%",
              poVal:
                (poValue *
                  (100 + Number(po?.gstDetails?.[0]?.rate || 0))) /
                100 +
                (po?.freight || 0) -
                (po?.discount || 0) +
                (po?.transportationCharge || 0),
              materialStatus: null,
            });
          } else {
            csvArray.push({
              vendorUniqueNo: null,
              poSoNumber: null,
              raisedBy: null,
              grnNumber: null,
              poSoDate: null,
              materialName: null,
              pricePerUnit: null,
              quantity: null,
              requestedQuantity: null,
              transportationCharge: po?.transportationCharge || 0,
              itemTotal: null,
              discount: "NA",
              freight: "NA",
              gstRate: "NA",
              poVal: poValue,
              materialStatus: null,
            });
          }
        }
      }

      if (csvArray.length === 0) {
        props.setSnackInfo("No data found for the selected criteria", "warning");
      } else {
        setCsvData(csvArray);
        downloadExcel();
      }

    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }

    props.setLoading(false);
  };

  const downloadExcel = () => {
    props.setLoading(true)
    try {
      setTimeout(() => {
        buttonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    props.setLoading(false)
  }

  const getVendors = async (page = 1, itemsPerPage = 10, projectIds = [], fromDate = '', toDate = '') => {
    setIsLoadingVendors(true)
    try {
      let params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', itemsPerPage);
      
      if (projectIds && projectIds.length > 0) {
        params.append('projectIds', projectIds.join(','));
      }
      
      if (fromDate && toDate) {
        params.append('fromDate', fromDate);
        params.append('toDate', toDate);
      } else if (fromDate) {
        params.append('fromDate', fromDate);
      } else if (toDate) {
        params.append('toDate', toDate);
      }
      
      const result = await HttpService.getAllVendorsPaginated(params.toString())
      setVendors(result.data.vendors)
      setCurrentPage(result.data.currentPage)
      setTotalPages(result.data.totalPages)
      setTotalCount(result.data.totalCount)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setIsLoadingVendors(false)
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value)
    if (!isSearching) {
      getVendors(value, limit, projectsIds, fromDateValue, toDateValue)
    }
  }

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value)
    setLimit(newLimit)
    setCurrentPage(1)
    if (!isSearching) {
      getVendors(1, newLimit, projectsIds, fromDateValue, toDateValue)
    }
  }

  const handleProjectIds = async (event, selectedOptions) => {
    setSelectedProjects(selectedOptions)
    let ids = selectedOptions.map(el => el._id)
    setProjectsIds(ids)
  }

  const searchVendor = async (event, selectedVendors) => {
    if (selectedVendors.length === 0) {
      setIsSearching(false)
      getVendors(1, limit, projectsIds, fromDateValue, toDateValue)
    } else {
      setIsSearching(true)
      const filteredVendors = allVendorsList.filter(vendor => 
        selectedVendors.some(selected => selected._id === vendor._id)
      )
      setVendors(filteredVendors)
      setTotalCount(filteredVendors.length)
      setTotalPages(1)
      setCurrentPage(1)
    }
  }

  const updateVendor = (e, data) => {
    props.setVendorName(data)
    history.push({
      pathname: '/vendor_po/all',
      state: {
        vendorName: data?.name,
        vendorId: data?._id,
        projectIds: projectsIds
      }
    })
  }

  useEffect(() => {
    const initializeData = async () => {
      await getVendors(1, limit, [], '', '')
      await loadAllVendorsForSearch()
      await getApprovedProjects()
    }
    initializeData()
  }, []) // Empty dependency array - runs once on mount

  return (
    <div>
      <Paper>
        <div className={classes.filterContainer}>
          <Autocomplete
            multiple
            onChange={searchVendor}
            id="users-dropdown"
            options={allVendorsList}
            getOptionLabel={(option) => option.name}
            style={{ width: 300 }}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Search By Vendors"
                placeholder="Enter the Vendor Name"
                size="small"
              />
            )}
          />
          
          <Autocomplete
            multiple
            onChange={handleProjectIds}
            value={selectedProjects}
            id="project-code-dropdownn"
            options={approvedProjects}
            getOptionLabel={(option) => option.searchName}
            style={{ width: 300 }}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Filter By Projects"
                placeholder="Enter the Project No."
                size="small"
              />
            )}
          />
          
          <TextField
            id="date"
            name="startDate"
            label="From Date"
            type="date"
            value={fromDateValue}
            onChange={e => handleFromDateChange(e)}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
          
          <TextField
            id="date"
            name="endDate"
            label="To Date"
            type="date"
            value={toDateValue}
            onChange={e => handleToDateChange(e)}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
          
          <div className={classes.buttonGroup}>
            <Button 
              variant="contained" 
              onClick={applyFilters}
              style={{ backgroundColor: '#F47E46', color: 'white' }}
              size="small"
            >
              Apply Filters
            </Button>
            
            {(projectsIds.length > 0 || fromDateValue || toDateValue) && (
              <Button 
                variant="outlined" 
                onClick={clearFilters}
                size="small"
              >
                Clear Filters
              </Button>
            )}
          </div>
        </div>
      </Paper>
      
      {!isSearching && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', alignItems: 'center' }}>
            <div>
              {(projectsIds.length > 0 || fromDateValue || toDateValue) && (
                <span style={{ color: '#1976d2', fontSize: '14px' }}>
                  Filters Applied
                </span>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span>Rows per page:</span>
              <select 
                value={limit} 
                onChange={handleLimitChange}
                style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span>
                Showing {totalCount === 0 ? 0 : ((currentPage - 1) * limit) + 1} to {Math.min(currentPage * limit, totalCount)} of {totalCount} vendors
              </span>
            </div>
          </div>

          {totalPages > 1 && (
            <div className={classes.pagination}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </div>
          )}
        </>
      )}

      {isSearching && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
          <span style={{ backgroundColor: '#e3f2fd', padding: '5px 10px', borderRadius: '4px' }}>
            Found {totalCount} vendor(s)
          </span>
        </div>
      )}

      <TableContainer component={Paper} className={classes.tableContainer}>
        {isLoadingVendors && (
          <div className={classes.loadingOverlay}>
            <div>Loading vendors...</div>
          </div>
        )}
        <Table className={classes.table} size="small" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ textAlign: 'center' }}>Vendor Unique No</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Name</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Address</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Phone No</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Email</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>POs/SOs</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}><span >Get</span><Button variant="contained" style={{ backgroundColor: '#355025', color: '#FFF2EB', padding: '0', marginBottom: '2px', borderRadius: '20px' }} onClick={handleCsvButton}>CSV</Button></StyledTableCell>
              <CSVLink
                headers={headers}
                filename={`vendors_${moment().format('DD-MM-YYYY')}.csv`}
                data={csvData}
                ref={buttonRef}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            {vendors?.map((data, i) => (
              <StyledTableRow key={data?._id || i + 1}>
                <StyledTableCell style={{ textAlign: 'center' }}>{data?.vendorUniqueNo}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{data?.name}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{data?.address}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{data?.contactNumber}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{data?.email}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  <Button 
                    variant="contained" 
                    style={{ backgroundColor: '#F47E46', color: '#FFF2EB' }} 
                    onClick={(e) => updateVendor(e, data)}
                    size="small"
                  >
                    View
                  </Button>
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  <Checkbox
                    name="csvCheckbox"
                    color="primary"
                    onChange={e => handleCheckBox(e, data?._id)}
                    checked={checkArr.includes(data?._id)}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
            {vendors?.length === 0 && !isLoadingVendors && (
              <StyledTableRow>
                <StyledTableCell colSpan={7} style={{ textAlign: 'center' }}>
                  No vendors found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default connect(null, { setLoading, setSnackInfo, getAllUnits, getAllMaterials, setVendorName, getApprovedProjects })(Vendors)
